export { default } from './NewSearchButton';



// WEBPACK FOOTER //
// ./app/components/search/NewSearchButton/index.js